const GREETING = 'Hoi {{voornaam}},';
const SIGNOFF = 'Groet,\n{{afzender_naam}}';
export const TEMPLATE_BLUEPRINTS = {
    cold_outreach: {
        category: 'cold_outreach',
        subject_template: '{{voornaam}}, korte vraag over {{company}}',
        structure_steps: [
            'Hook — 1 zin persoonlijk (bedrijf/situatie)',
            'Waarde — wat levert het op (max. 2 zinnen)',
            'Vraag — één duidelijke yes/no of kalender-vraag',
            'Afsluiting — groet + naam',
        ],
        blocks: [
            {
                type: 'paragraph',
                text: `${GREETING}\n\nIk zag {{company}} en vroeg me af of jullie openstaan voor een kort gesprek over [jullie doel].`,
            },
            {
                type: 'paragraph',
                text: 'Wij helpen vergelijkbare bedrijven met [concrete uitkomst] — zonder lange trajecten.',
            },
            {
                type: 'paragraph',
                text: `Heb je 15 minuten deze of volgende week voor een belletje?\n\n${SIGNOFF}`,
            },
        ],
    },
    backlink: {
        category: 'backlink',
        subject_template: 'Gastartikel idee voor {{company}}',
        structure_steps: [
            'Context — waarom je mailt (relevantie voor hun site)',
            'Voorstel — gastartikel / samenwerking in 1–2 zinnen',
            'Bullets — 2 redenen waarom het past bij hun publiek',
            'Zachte CTA — link of reply',
        ],
        blocks: [
            {
                type: 'paragraph',
                text: `${GREETING}\n\nIk volg jullie site rond [thema] en heb een gastartikel-idee dat past bij jullie publiek.`,
            },
            {
                type: 'paragraph',
                text: 'Het stuk gaat over [onderwerp] — praktisch, zonder salespitch, wel met nut voor jullie lezers.',
            },
            {
                type: 'paragraph',
                text: '• Sluit aan bij wat jullie al publiceren over [thema]\n• Schrijf ik op maat; jullie houden volledige redactionele regie',
            },
            {
                type: 'cta',
                label: 'Bekijk outline',
                url_template: 'https://jouwsite.nl/voorbeeld-artikel',
            },
            {
                type: 'paragraph',
                text: `Past dit? Reply gerust — dan stuur ik een korte outline.\n\n${SIGNOFF}`,
            },
        ],
    },
    partnership: {
        category: 'partnership',
        subject_template: 'Samenwerking {{company}} × {{merk}}?',
        structure_steps: [
            'Hook — overlap in doelgroep of waarden',
            'Voorstel — vorm van partnership',
            'Bewijs — 1 zin social proof',
            'Vraag — volgende stap',
        ],
        blocks: [
            {
                type: 'paragraph',
                text: `${GREETING}\n\n{{company}} en wij richten ons beide op [doelgroep] — daarom dacht ik aan een mogelijke samenwerking.`,
            },
            {
                type: 'paragraph',
                text: 'Denk aan [co-marketing / referral / joint webinar] — laagdrempelig om te verkennen.',
            },
            {
                type: 'paragraph',
                text: 'We deden iets vergelijkbaars met [referentie]; het leverde [kort resultaat] op.',
            },
            {
                type: 'paragraph',
                text: `Zou je openstaan voor een kort kennismakingsgesprek?\n\n${SIGNOFF}`,
            },
        ],
    },
    broadcast: {
        category: 'broadcast',
        subject_template: '[Nieuws] Update voor {{company}}',
        structure_steps: [
            'Onderwerpregel — duidelijk nieuws, geen clickbait',
            'Kern — wat is er nieuw (1 alinea)',
            'Actie — één CTA of link',
            'Afsluiting',
        ],
        blocks: [
            {
                type: 'heading',
                text: 'Korte update',
            },
            {
                type: 'paragraph',
                text: `${GREETING}\n\nWe hebben [nieuws/product/lancering] — relevant als jij met [thema] bezig bent.`,
            },
            {
                type: 'cta',
                label: 'Lees meer',
                url_template: 'https://jouwsite.nl/nieuws',
            },
            {
                type: 'paragraph',
                text: SIGNOFF,
            },
        ],
    },
};
export function getTemplateBlueprint(category) {
    return TEMPLATE_BLUEPRINTS[category];
}
export function cloneBlueprintBlocks(category) {
    return structuredClone(getTemplateBlueprint(category).blocks);
}
export function blueprintSubject(category) {
    return getTemplateBlueprint(category).subject_template;
}
export function suggestedInternalTemplateName(projectLabel, category, touch = 'touch-1') {
    const slug = category.replace(/_/g, '-');
    const proj = projectLabel.trim() || 'Project';
    return `${proj} | ${slug} | ${touch}`;
}
/** Fase 1 — geen ellipsis-placeholders in productie-copy. */
const PLACEHOLDER_RE = /(\.\.\.|…)/;
export function templateHasWeakPlaceholders(parts) {
    if (parts.subject && PLACEHOLDER_RE.test(parts.subject))
        return true;
    if (parts.body_text && PLACEHOLDER_RE.test(parts.body_text))
        return true;
    if (parts.blocks) {
        for (const b of parts.blocks) {
            if (b.type === 'paragraph' || b.type === 'heading') {
                if (PLACEHOLDER_RE.test(b.text))
                    return true;
            }
        }
    }
    return false;
}
export function validateTemplatePhase1(parts) {
    const warnings = [];
    if (!parts.subject.trim())
        warnings.push('Onderwerp is leeg.');
    if (templateHasWeakPlaceholders({ subject: parts.subject, blocks: parts.blocks })) {
        warnings.push('Vervang "…" of "..." door echte copy — geen placeholder-ellipsis.');
    }
    const hasParagraph = parts.blocks.some((b) => (b.type === 'paragraph' || b.type === 'heading') && b.text.trim().length > 10);
    if (!hasParagraph)
        warnings.push('Voeg minstens één alinea met inhoud toe.');
    if (!parts.subject.includes('{{') && parts.subject.length < 8) {
        warnings.push('Onderwerp mag kort zijn, maar moet wel concreet zijn.');
    }
    return { ok: warnings.length === 0, warnings };
}
export const STANDARD_TEMPLATE_VARIABLES = [
    '{{voornaam}}',
    '{{company}}',
    '{{email}}',
    '{{afzender_naam}}',
];
//# sourceMappingURL=templateBlueprint.js.map